import React, { useState } from 'react';
import { Alert, TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col, Container, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import classnames from 'classnames';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { MdMyLocation } from 'react-icons/md';
import { FaInfoCircle } from 'react-icons/fa';


var tabActual = 1;
var tabActualString = 1;
const bannerMensaje = (props) => {

    var Option3;
    console.log(props.state)
    console.log(props.state.Estado)
        
        if (props.state.Estado == "DISPERSADO" ) {
            Option3 = <div>
                <h5 className="mensajeExitoso no-print">¡Felicidades {props.state.Nombres + " " + props.state.ApellidoP} tu crédito ha sido <div className="ColorGreen"> &nbsp;Dispersado</div>!</h5>
            </div>;
        }
    else if ( props.state.Estado == "APROBADA") {
        Option3 = <div>
            <h5 className="mensajeExitoso no-print">¡Felicidades {props.state.Nombres + " " + props.state.ApellidoP} tu solicitud ha sido <div className="ColorGreen"> &nbsp;Aprobado</div>!</h5>
        </div>;
    }
    
        else {
            Option3 = <div><h5>La solicitud se encuentra en el estado <div className="ColorRed no-print">{props.state.Estado}.</div> </h5>   </div>;
        }


    



    return (
        <div>
            {Option3}
        </div>
    );

}

export default bannerMensaje;